import { render, staticRenderFns } from "./exam-result.vue?vue&type=template&id=45c6145e&scoped=true&"
import script from "./exam-result.vue?vue&type=script&lang=ts&"
export * from "./exam-result.vue?vue&type=script&lang=ts&"
import style0 from "./exam-result.vue?vue&type=style&index=0&id=45c6145e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6145e",
  null
  
)

export default component.exports